import { render, staticRenderFns } from "./PercentButtons.vue?vue&type=template&id=12656543"
import script from "./PercentButtons.vue?vue&type=script&lang=js"
export * from "./PercentButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports